import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
const isTicketField = formField => formField.objectTypeId === FormFieldPropertyObjectTypesIds.TICKET;
export default isTicketField;